import {
  Card,
  Flex,
  Skeleton,
  SkeletonBodyText,
  SkeletonBox,
  SkeletonHeading,
} from '@utilitywarehouse/hearth-react';

const SimPlanTileSkeleton = () => (
  <Card flex="1 1 0" height="auto">
    <Skeleton loadingTitle="SIM plan tile loading" width="100%">
      <Flex direction="column" spacing="lg">
        <SkeletonHeading size="lg" width="70%" />
        <SkeletonHeading size="xl" />
        <ul className="sim-tile__benefits">
          <li>
            <SkeletonBodyText width="70%" />
          </li>
          <li>
            <SkeletonBodyText width="70%" />
          </li>
          <li>
            <SkeletonBodyText width="70%" />
          </li>
          <li>
            <SkeletonBodyText width="70%" />
          </li>
        </ul>
        <SkeletonBox borderRadius="sm" height="45px" />
      </Flex>
    </Skeleton>
  </Card>
);

export { SimPlanTileSkeleton };
